import type { NotificationType } from '../types';

export const notificationsKeys = {
    all: ['notifications'] as const,
    unreadCount: () => [...notificationsKeys.all, 'unread-count'] as const,
    list: (type: NotificationType, limit: number) =>
        [...notificationsKeys.all, 'list', type, limit] as const,
    listInfinite: (type: NotificationType) =>
        [...notificationsKeys.all, 'list-infinite', type] as const,
} as const;
